import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'react-circular-progressbar/dist/styles.css';
import 'react-responsive-modal/styles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Chart from 'chart.js/auto';

import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui.min.js';

window.$ = $;
window.jQuery = $;

// const rootReducer = combineReducers({
//     ui_red:UIreducer,
// });
// const store = createStore(rootReducer);
const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <ToastContainer />
    </BrowserRouter>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(app);

serviceWorker.unregister();
